import { MultiSelect } from 'legacy/lut/library/multiSelect'
import { useCallback, useMemo } from 'react'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

import styles from '../QBRDocumentsFilterArea.module.scss'

interface IQBRCreatorsFilterProps {
  qbrDocumentsData: IQBRDocumentsListItem[]
  creatorsValue: string[]
  onChangeCreatorsValue: (value: string[]) => void
}

export const QBRCreatorsFilter = ({
  qbrDocumentsData,
  creatorsValue,
  onChangeCreatorsValue,
}: IQBRCreatorsFilterProps) => {
  const creatorArray = qbrDocumentsData.map((values) => {
    return values.CreatedBy
  })

  const crud = useMemo(() => {
    return new Crud({
      fetcher: new Static([...new Set(creatorArray)].map((el) => ({ value: el }))),
      keyField: 'value',
      defaultSort: { field: 'value', dir: 'asc' },
      defaultPaging: { page: 0, pageSize: creatorArray.length },
    })
  }, [creatorArray])

  const onCreatorsChange = useCallback(
    (value: string[]) => {
      onChangeCreatorsValue(value)
    },
    [onChangeCreatorsValue]
  )

  return (
    <div className={styles.filter}>
      <MultiSelect
        value={creatorsValue}
        source={crud}
        label="Creators"
        caption={'value'}
        onChange={onCreatorsChange}
      />
    </div>
  )
}
